import React from 'react';
import Navbar from '../components/Navbar';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import SEOHelmet from '../components/SEOHelmet';
import SocialShare from '../components/SocialShare';
import { pagesSEO } from '../utils/seoConfig';

const ContactPage = () => {
  return (
    <>
      <SEOHelmet 
        title={pagesSEO.contact.title}
        description={pagesSEO.contact.description}
        keywords={pagesSEO.contact.keywords}
        canonical={pagesSEO.contact.canonical}
      />
      <div className="contact-page">
        <Navbar />
        <main>
          <h1 className="sr-only">聯絡我們 - 聯漢室內設計工作室</h1>
          <Breadcrumb currentPage="聯絡我們" />
          <Contact />
          <SocialShare 
            title="聯絡聯漢室內設計工作室 - 專業室內設計諮詢"
            description="立即聯絡聯漢室內設計工作室，獲得專業室內設計諮詢服務。服務台東、高雄地區，提供住宅設計、商業空間設計、舊屋翻新等專業服務。"
            url="http://www.lan-hung560.com.tw/contact"
          />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ContactPage; 